import { useRef, useEffect, useState } from "react";
import "../IdealFor.css";
import battery_charge_car from "../../../assets/battery_charge_car.png";
import car_charging from "../../../assets/car_charging.png";
import house_full_battery from "../../../assets/house_full_battery.png";
import light_bulb from "../../../assets/light_bulb.png";

const cards = [
  { image: house_full_battery, alt: "Home with solar and battery", text: "Homes adding or upgrading to hybrid inverter and battery systems" },
  { image: battery_charge_car, alt: "Energy independence", text: "Households wanting dependable backup and day-to-day energy management" },
  { image: light_bulb, alt: "Smart energy use", text: "Owners who may join VPP or export programs where the product is eligible" },
  { image: car_charging, alt: "Future-ready home", text: "Families planning to expand storage or add EVs over time" },
];

function IdealCard({ image, alt, text, mobile = false }) {
  const cardClass = mobile ? "ideal-family-card-mobile" : "ideal-family-card";
  const imgContainerClass = mobile ? "ideal-card-image-container-mobile" : "ideal-card-image-container";
  const imgClass = mobile ? "ideal-card-image-mobile" : "ideal-card-image";
  const labelClass = mobile ? "ideal-card-label-manufacture-mobile" : "ideal-card-label-manufacture";
  return (
    <div className={cardClass}>
      <div className={imgContainerClass}>
        <img src={image} alt={alt} className={imgClass} />
      </div>
      <div className={labelClass}>
        <p>{text}</p>
      </div>
    </div>
  );
}

export default function IdealFor() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`ideal-designed-manufacture-section ${inView ? "ideal-in-view" : ""}`}>
      <div className="ideal-manufacture-header">
        <h1>Ideal For</h1>
      </div>
      <div className="ideal-manufacture-grid ideal-manufactore-desktop-grid">
        {cards.map((c, i) => (
          <IdealCard key={i} image={c.image} alt={c.alt} text={c.text} mobile={false} />
        ))}
      </div>
      <div className="ideal-manufacture-stack mobile-stack">
        {cards.map((c, i) => (
          <IdealCard key={i} image={c.image} alt={c.alt} text={c.text} mobile={true} />
        ))}
      </div>
    </div>
  );
}
